import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconRuby = ({
  title = "Ruby",
  viewBoxWidth = 56,
  viewBoxHeight = 44,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g fill="none" fillRule="evenodd">
      <path d="M0-7h56v56H0z" />
      <path fill="#900" d="M34.607 12.742H56L28 44.045z" />
      <path fill="#FA7B7C" d="M0 12.742h21.393l6.608 31.303z" />
      <path fill="#D50000" d="M17.618 12.742h20.764L28.001 44.045z" />
      <path fill="#FA7B7C" d="M9.281 0H28v12.742H9.281z" />
      <path fill="#FD0101" d="M28 0h18.562v12.742H28z" />
      <path fill="#900" d="M17.618 12.742h20.764L28 0z" />
      <path fill="#D50000" d="M38.382 12.742H56L46.247 0z" />
      <path fill="#FD0101" d="M0 12.742h17.618L9.281 0z" />
    </g>
  </Svg.Icon>
)

export default IconRuby
